export default "__VITE_ASSET__BElz8CWm__"